//Modules
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { HttpClientModule } from "@angular/common/http";
//import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha";

//Components
import { AppComponent } from "./app.component";
import { EngineComponent } from "./components/engine/engine.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { ModalComponent } from "./components/modal/modal.component";
import { InformationComponent } from "./components/modal/information/information.component";
import { VisualizatorComponent } from "./components/modal/visualizator/visualizator.component";
import { SpinnerComponent } from "./components/loading/spinner/spinner.component";
import { HelpComponent } from "./components/modal/help/help.component";
import { Info360ContainerComponent } from "./components/modal/info360-container/info360-container.component";
import { ContactFormComponent } from "./components/common/contact-form/contact-form.component";

//Services
import { WindowRefService } from "./services/window-ref.service";
import { WalkthroughService } from "./services/walkthrough.service";
import { ImageService } from "./services/image.service";
import { ContactService } from "./services/contact.service";
import { FullscreenService } from "./services/fullscreen.service";

//Pipes
import { SafeURLPipe } from "./pipes/safe-url.pipe";
import { GalleryComponent } from "./components/modal/gallery/gallery.component";
import { ViewerComponent } from './components/common/viewer/viewer.component';

@NgModule({
  declarations: [
    AppComponent,
    EngineComponent,
    NotFoundComponent,
    ModalComponent,
    InformationComponent,
    VisualizatorComponent,
    SafeURLPipe,
    SpinnerComponent,
    HelpComponent,
    Info360ContainerComponent,
    ContactFormComponent,
    GalleryComponent,
    ViewerComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    // RecaptchaModule,
    // RecaptchaFormsModule,
  ],
  providers: [
    WindowRefService,
    WalkthroughService,
    ImageService,
    ContactService,
    FullscreenService,
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {}
